import type { ReactNode } from "react";

export function HeaderIcon({ children }: { children: ReactNode }) {
  return (
    <div className="flex items-center justify-center size-8 rounded-full">
      <svg viewBox="0 0 22 22" width="20" height="20">
        {children}
      </svg>
    </div>
  );
}

export const SearchIcon = (
  <>
    <circle cx="9" cy="9" r="6" stroke="currentColor" strokeWidth="1.6" fill="none" />
    <path d="m13.5 13.5 4 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </>
);

export const SidebarIcon = (
  <>
    <rect x="3" y="4" width="16" height="14" rx="2" stroke="currentColor" strokeWidth="1.6" fill="none" />
    <line x1="13" y1="4" x2="13" y2="18" stroke="currentColor" strokeWidth="1.6" />
  </>
);

export const KebabIcon = (
  <>
    <circle cx="11" cy="5" r="1.4" fill="currentColor" />
    <circle cx="11" cy="11" r="1.4" fill="currentColor" />
    <circle cx="11" cy="17" r="1.4" fill="currentColor" />
  </>
);

export function PaperclipIcon() {
  return (
    <svg viewBox="0 0 22 22" width="22" height="22">
      <path
        d="M14 6 L7.5 12.5 a2.5 2.5 0 0 0 3.5 3.5 L17.5 9.5 a4 4 0 0 0 -5.5 -5.5 L5 11 a5.5 5.5 0 0 0 7.5 7.5 L19 12"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EmojiIcon() {
  return (
    <svg viewBox="0 0 22 22" width="22" height="22">
      <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <circle cx="8" cy="9.5" r="0.9" fill="currentColor" />
      <circle cx="14" cy="9.5" r="0.9" fill="currentColor" />
      <path d="M7.5 13 a4 2.5 0 0 0 7 0" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    </svg>
  );
}

export function MicIcon() {
  return (
    <svg viewBox="0 0 22 22" width="22" height="22">
      <rect x="8" y="3" width="6" height="11" rx="3" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <path d="M5 11 a6 6 0 0 0 12 0 M11 17 v3" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    </svg>
  );
}

export function ReadTicks() {
  return (
    <svg viewBox="0 0 16 10" width="14" height="9" className="ml-px">
      <path d="M1 5 L4.5 8.5 L10 2" stroke="var(--color-tg-time-out)" strokeWidth="1.4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 5 L9.5 8.5 L15 2" stroke="var(--color-tg-time-out)" strokeWidth="1.4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
